import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { TreeSelect } from "antd";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { getProductTemplate } from "actions/productTemplateAction";
import { getCategories } from "actions/categoryAction";
import { getCategoriesProduct } from "actions/categoryProductAction";
import SelectBox from "components/elements/selectBox";
import Select from "react-select";

function ModalTemplate({ onSubmit, productTemplate, getProductTemplate, getCategories, getCategoriesProduct, user }) {
    var { _id: user_id, parentId } = user.user;
    const [isOpen, setIsOpen] = useState(false);
    const [templateID, setTemplateID] = useState("");
    const [otherImage, setOtherImage] = useState("");
    const [category, setCategory] = useState("");
    const [categoryVersion, setCategoryVersion] = useState("v2");
    const [categories, setCategories] = useState([]);
    const [numberImage, setNumberImage] = useState(9);
    const [removePrdImport, setRemovePrdImport] = useState(true);
    const [categoriesProduct, setCategoriesProduct] = useState("");
    const [listCategoriesProduct, setListCategoriesProduct] = useState([]);
    const [currency, setCurrency] = useState("USD");
    const [attribute_products, setAttributeProducts] = useState((user_id === "677b52f770b21db16cbb1dbd" || parentId === "677b52f770b21db16cbb1dbd") ? "default" : "none");
    const { t } = useTranslation();

    useEffect(() => {
        getProductTemplate({ page: 1, sizeperpage: 9999 });
    }, [getProductTemplate]);

    useEffect(() => {
        getCategoriesProduct({ page: 1, sizeperpage: 9999 }).then((data) => {
            setListCategoriesProduct(
                data?.categoryProducts?.map((cate) => ({ value: cate?._id, label: cate.title })) || []
            );
        });
    }, [getCategoriesProduct]);

    useEffect(() => {
        getCategories(() => { }, categoryVersion).then((data) =>
            setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })))
        );
    }, [categoryVersion, getCategories]);

    useEffect(() => {
        getProductTemplate({ page: 1, sizeperpage: 9999 });
    }, [getProductTemplate]);

    const onChangeTemplate = (e) => {
        setTemplateID(e?.value || "");
    };

    const handleSubmit = () => {
        onSubmit({
            templateId: templateID,
            removePrdImport,
            categoryId: category,
            otherImage: otherImage?.split("\n") || [],
            numberImage: numberImage,
            categoryVersion,
            categories: categoriesProduct,
            attribute_products,
            currency,
        });
        setIsOpen(false);
    };

    return (
        <Fragment>
            <button onClick={() => setIsOpen(true)} type="button" className="btn btn-primary btn-sm me-1">
                <i className="fa fa-cloud-upload mr-1"></i> {t("Import To System")}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    setIsOpen(!isOpen);
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h2 className="mb-0 text-info">You're preparing to upload products to your account</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                setIsOpen(!isOpen);
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex justify-content-between mb-5 w-100 flex-column gap-4">
                        {/* <div className="form-group w-100">
                            <label className="required">Template</label>
                            <div>
                                <Select
                                    isClearable
                                    name="templateID"
                                    options={productTemplate}
                                    className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-0 al-filter-table w-100"
                                    classNamePrefix="select"
                                    value={productTemplate.filter(({ value }) => templateID === value)}
                                    onChange={(e) => {
                                        onChangeTemplate(e);
                                    }}
                                    placeholder={t("Select a template ... ")}
                                />
                            </div>
                        </div> */}
                        <div className="form-group w-100">
                            <label className="required">Category</label>
                            <div className="row">
                                <div className="col-md-10">
                                    <TreeSelect
                                        showSearch
                                        style={{ width: "100%" }}
                                        treeNodeFilterProp="label"
                                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                                        className="h-100"
                                        placeholder="Please select"
                                        onChange={(cate) => {
                                            setCategory(cate);
                                        }}
                                        treeData={categories}
                                        value={category}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SelectBox
                                        options={[
                                            { value: "v1", label: "v1" },
                                            { value: "v2", label: "v2" },
                                        ]}
                                        className="h-100"
                                        name="category_version"
                                        value={categoryVersion || "v2"}
                                        onChange={(data) => {
                                            setCategoryVersion(data?.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group w-100">
                                    <label className="d-flex align-items-center mb-0">
                                        <span className="">{t("Attribute Product")}</span>
                                    </label>
                                    <select className="form-select" name="attribute_products" value={attribute_products} onChange={(e) => setAttributeProducts(e.target.value)}>
                                        <option value="default">Default</option>
                                        <option value="none">None</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group w-100">
                                    <label className="d-flex align-items-center mb-0">
                                        <span className="">{t("Niche")}</span>
                                    </label>
                                    <Select
                                        isClearable
                                        name="filter_categories"
                                        options={listCategoriesProduct}
                                        value={listCategoriesProduct.filter(({ value }) => value === categoriesProduct)}
                                        className="basic-multi-select al-custom-select-search-variants mt-0 me-2 mb-0 al-filter-table w-100"
                                        classNamePrefix="select"
                                        onChange={(data) => {
                                            setCategoriesProduct(data?.value || "");
                                        }}
                                        placeholder={t(`Select a category ... `)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group w-100">
                                    <label className="d-flex align-items-center mb-0">
                                        <span className="">{t("Currency")}</span>
                                    </label>
                                    <select className="form-select" name="currency" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                                        <option value="USD">United States</option>
                                        <option value="EUR">France, Germany, Ireland, Italy, Spain</option>
                                        <option value="GBP">United Kingdom</option>
                                        <option value="IDR">Indonesia</option>
                                        <option value="JPY">Japan</option>
                                        <option value="MXN">Mexico</option>
                                        <option value="MYR">Malaysia</option>
                                        <option value="PHP">Philippines</option>
                                        <option value="SGD">Singapore</option>
                                        <option value="THB">Thailand</option>
                                        <option value="VND">Vietnam</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-group w-100">
                            <label className="required">Total Image:</label>
                            <div>
                                <input
                                    type="number"
                                    value={numberImage}
                                    min={1}
                                    name="numberImage"
                                    className="form-control"
                                    onChange={(e) => {
                                        setNumberImage(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Other Image Secondary by URL</label>
                            <div className="mb-5">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="otherImage"
                                    placeholder="https://image.com/1.png
https://image.com/2.jpg
https://image.com/3.gif
..."
                                    rows={5}
                                    defaultValue={otherImage}
                                    onChange={(e) => {
                                        setOtherImage(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="row">
                                {otherImage?.split("\n").length > 0 &&
                                    otherImage?.split("\n")?.map((v, i) => (
                                        <div key={i} className="col-3">
                                            <img className="responsive p-2" alt="" src={v} width={200} />
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="form-group w-100">
                            <label className="required">Remove Product Import Success</label>
                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                    <input
                                        className="form-check-input w-45px h-30px"
                                        type="checkbox"
                                        id="manage_product"
                                        checked={removePrdImport}
                                        name="manage_product"
                                        onChange={(e) => {
                                            setRemovePrdImport(e.target.checked);
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="manage_product"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Start Upload")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    productTemplate: state.productTemplate?.list?.map((v, i) => {
        return { value: v._id, label: v.title };
    }),
    user: state.user,
});
const mapDispatchToProps = { getProductTemplate, getCategories, getCategoriesProduct };

export default connect(mapStateToProps, mapDispatchToProps)(ModalTemplate);
